import React from "react";
import { STORAGE_URL } from "constants";

const DocumentModal = ({ document }) => {
  return (
    <div className="position-relative h-100">
      <iframe
        id="msdoc-iframe"
        title="msdoc-iframe"
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${STORAGE_URL}${document?.link}`}
        frameborder="0"
        class="w-100 h-100"
      ></iframe>
      <img
        src={"/images/logo.svg"}
        alt=""
        className="position-absolute"
        style={{ bottom: -10, right: -25 }}
      />
    </div>
  );
};
export default DocumentModal;
